/* eslint-disable eag/no-css-property */
/* eslint-disable react/forbid-component-props */
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import {css} from 'styled-components';

interface TextProps {
  type: 'agent' | 'customer';
}

export function Text(props: TextProps) {
  return (
    <ContentEditable
      css={css`
        color: ${
          props.type === 'agent'
            ? ({theme}) => theme.colors.text.white
            : ({theme}) => theme.colors.text.primary
        };
        font-size: ${({theme}) => theme.fontSizes.text.small};
        line-height: ${({theme}) => theme.lineHeights.text.small};

        a {
          color: ${
            props.type === 'agent'
              ? ({theme}) => theme.colors.palettes.blue[30][100]
              : ({theme}) => theme.colors.text.link
          };

          &:hover {
            text-decoration: underline;
          }
        }
      `}
    />
  );
}
